
import {
  defineComponent,
  ref,
  computed,
  watch,
} from 'vue';

import { useCreatedDevAPP } from '../composables/index';
import { IAddAccountAppPrams } from '@/api/manage-app/app-info/index.d';
import { useAppList } from '@/views/app/app-manage/composables/useAppList';

export default defineComponent({
  name: 'CreatedDevAPP',
  emits: ['update:visible', 'handleSearch'],
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    accountAppItem: {
      type: Object,
      default: () => ({}),
    },
    accountId: {
      type: String,
      default: '',
    },
    accountInfoId: {
      type: String,
      default: '',
    },
  },
  setup(props, { emit }) {
    const selfVisible = computed({
      get() {
        return props.visible;
      },
      set(val: boolean) {
        emit('update:visible', val);
      },
    });
    const formData = ref<IAddAccountAppPrams>({
      accountInfoId: props.accountInfoId,
      accountId: props.accountId,
      bundleId: '', // bundle-id
      appClient: '', // 应用名称
      installAddress: '', // 下载地址
    });

    const {
      handleAPPSave,
      handleAPPClose,
    } = useCreatedDevAPP(
      formData,
      emit as any,
    );

    watch(props, (val) => {
      if (val.visible && props.accountAppItem.id) {
        formData.value = props.accountAppItem as IAddAccountAppPrams;
        formData.value.accountInfoId = props.accountAppItem.accountInfoId;
        formData.value.accountId = props.accountAppItem.accountId;
      } else {
        formData.value = Object.assign({}, {
          accountInfoId: props.accountInfoId,
          accountId: props.accountId,
          bundleId: '', // bundle-id
          appClient: '', // 应用名称
          installAddress: '', // 下载地址
        });
      }
    });

    const { appList } = useAppList();

    return {
      formData,
      selfVisible,
      rules: {
        bundleId: [
          { required: true, message: '请输入bundle-id', trigger: 'blur' },
        ],
        appClient: [
          { required: true, message: '请选择应用名称', trigger: 'change' },
        ],
        installAddress: [
          { required: true, message: '请输入下载地址', trigger: 'blur' },
        ],
      },
      handleAPPSave,
      handleAPPClose,
      APPS: [
      // { name: '直销 APP', code: 'INNER_APP', updateType: 'UpdateInner' },
      // { name: '百布 APP', code: 'BAIBU_APP', updateType: 'UpdateOutside' },
        // { name: '找布易 APP', code: 'SELLER_APP', updateType: 'UpdateOutside' },
        { name: '八爪鱼 APP', code: 'octopus_app' },
        { name: '致衣 APP', code: 'zhicloth_app' },
        { name: '天工 APP', code: 'tiangong_app' },
      ],
      appList,
    };
  },
});
